"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _element = require("@wordpress/element");

var _lodash = require("lodash");

var _i18n = require("@wordpress/i18n");

var _components = require("@wordpress/components");

var _blocks2 = require("@wordpress/blocks");

var _data = require("@wordpress/data");

var _icons = require("@wordpress/icons");

var _blockIcon = _interopRequireDefault(require("../block-icon"));

var _blockTransformationsMenu = _interopRequireDefault(require("./block-transformations-menu"));

var _blockStylesMenu = _interopRequireDefault(require("./block-styles-menu"));

/**
 * External dependencies
 */

/**
 * WordPress dependencies
 */

/**
 * Internal dependencies
 */
var BlockSwitcher = function BlockSwitcher(_ref) {
  var clientIds = _ref.clientIds;

  var _useDispatch = (0, _data.useDispatch)('core/block-editor'),
      replaceBlocks = _useDispatch.replaceBlocks;

  var _useSelect = (0, _data.useSelect)(function (select) {
    var _getBlockType;

    var _select = select('core/block-editor'),
        getBlocksByClientId = _select.getBlocksByClientId,
        getBlockRootClientId = _select.getBlockRootClientId,
        getBlockTransformItems = _select.getBlockTransformItems;

    var _select2 = select(_blocks2.store),
        getBlockStyles = _select2.getBlockStyles,
        getBlockType = _select2.getBlockType;

    var rootClientId = getBlockRootClientId((0, _lodash.castArray)(clientIds)[0]);

    var _blocks = getBlocksByClientId(clientIds);

    var isSingleBlockSelected = (_blocks === null || _blocks === void 0 ? void 0 : _blocks.length) === 1;
    var firstBlock = !!(_blocks !== null && _blocks !== void 0 && _blocks.length) ? _blocks[0] : null;
    var styles = isSingleBlockSelected && getBlockStyles(firstBlock.name); // When selection consists of blocks of multiple types, display an
    // appropriate icon to communicate the non-uniformity.

    var isSelectionOfSameType = (0, _lodash.uniq)((_blocks || []).map(function (_ref2) {
      var name = _ref2.name;
      return name;
    })).length === 1;
    return {
      blocks: _blocks,
      possibleBlockTransformations: _blocks && getBlockTransformItems(_blocks, rootClientId),
      hasBlockStyles: !!(styles !== null && styles !== void 0 && styles.length),
      icon: isSelectionOfSameType ? (_getBlockType = getBlockType(firstBlock.name)) === null || _getBlockType === void 0 ? void 0 : _getBlockType.icon : _icons.stack
    };
  }, [clientIds]),
      blocks = _useSelect.blocks,
      possibleBlockTransformations = _useSelect.possibleBlockTransformations,
      hasBlockStyles = _useSelect.hasBlockStyles,
      icon = _useSelect.icon;

  if (!(blocks !== null && blocks !== void 0 && blocks.length)) return null;

  var onTransform = function onTransform(name) {
    return replaceBlocks(clientIds, (0, _blocks2.switchToBlockType)(blocks, name));
  };

  var hasPossibleBlockTransformations = !!possibleBlockTransformations.length;

  if (!hasBlockStyles && !hasPossibleBlockTransformations) {
    return (0, _element.createElement)(_components.ToolbarGroup, null, (0, _element.createElement)(_components.ToolbarButton, {
      disabled: true,
      className: "block-editor-block-switcher__no-switcher-icon",
      title: (0, _i18n.__)('Block icon'),
      icon: (0, _element.createElement)(_blockIcon.default, {
        icon: icon,
        showColors: true
      })
    }));
  }

  var blockSwitcherLabel = 1 === blocks.length ? (0, _i18n.__)('Change block type or style') : (0, _i18n.sprintf)(
  /* translators: %s: number of blocks. */
  (0, _i18n._n)('Change type of %d block', 'Change type of %d blocks', blocks.length), blocks.length);
  return (0, _element.createElement)(_components.ToolbarGroup, null, (0, _element.createElement)(_components.ToolbarItem, null, function (toggleProps) {
    return (0, _element.createElement)(_components.DropdownMenu, {
      className: "block-editor-block-switcher",
      label: blockSwitcherLabel,
      popoverProps: {
        position: 'bottom right',
        isAlternate: true,
        className: 'block-editor-block-switcher__popover'
      },
      icon: (0, _element.createElement)(_blockIcon.default, {
        icon: icon,
        className: "block-editor-block-switcher__toggle",
        showColors: true
      }),
      toggleProps: toggleProps,
      menuProps: {
        orientation: 'both'
      }
    }, function (_ref3) {
      var onClose = _ref3.onClose;
      return (hasBlockStyles || hasPossibleBlockTransformations) && (0, _element.createElement)("div", {
        className: "block-editor-block-switcher__container"
      }, hasPossibleBlockTransformations && (0, _element.createElement)(_blockTransformationsMenu.default, {
        className: "block-editor-block-switcher__transforms__menugroup",
        possibleBlockTransformations: possibleBlockTransformations,
        blocks: blocks,
        onSelect: function onSelect(name) {
          onTransform(name);
          onClose();
        }
      }), hasBlockStyles && (0, _element.createElement)(_blockStylesMenu.default, {
        hoveredBlock: blocks[0],
        onSwitch: onClose
      }));
    });
  }));
};

var _default = BlockSwitcher;
exports.default = _default;
//# sourceMappingURL=index.js.map